import { useEffect, useState } from "react";
import axios from "axios";
import { FilterMatchMode } from 'primereact/api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { TreeTable } from 'primereact/treetable';
import { useToast } from '../../toastHook'
import { useAuthUser } from '../../auth'



export const CompetenceSimilaireComponent = () => {

    const { display } = useToast();
    const { checkRole } = useAuthUser();
    const [result, setResult] = useState(undefined);
    const [tableRows, setTableRows] = useState([]);
    const [count, setCount] = useState(0);

    const [filters, setFilters] = useState({
        nom: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        categorie: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    });

    useEffect(() => {
        axios.get("/api/competencesimilaire/skills")
            .then(response => {
                setResult(response.data);

                if (response.data) {
                    let tmpRows = [];

                    for (const key in response.data.competencesSimilaires) {
                        const value = response.data.competencesSimilaires[key];

                        const tmpValues = value.skills.map(x => {
                            return {
                                key: key + '-' + x.nom,
                                data: {
                                    competence: key,
                                    skillName: x.nom,
                                    skillCategorie: x.categorie,
                                    notUsed : undefined
                                }
                            }
                        })

                        tmpRows.push({
                            key: key,
                            data: {
                                competence: key,
                                skillName: '',
                                skillCategorie: '',
                                notUsed : value.notUsed
                            },
                            children: tmpValues
                        });
                    }

                    setTableRows(tmpRows);
                }
            }
            );
    },[count]);

    const changeNotUsed = competence => {

        if (!checkRole('Pocahontas_CompetenceSimilaire')) {
            return;
        }

        axios.get('/api/competencesimilaire/changenotused?competence=' + competence).then(response => {
            if (response.status == 200) {

                display({
                    titre: 'compétence activée / désactivée',
                    text: `la compétence bloquante '${competence}' a changé de status pour le 'NotUsed'`,
                    severity: 'success'
                });

                setCount(count + 1);
            }
            else {
                display({
                    titre: 'compétence activée / désactivée',
                    text: `la compétence bloquante '${competence}' n'a changé de status pour le 'NotUsed'`,
                    severity: 'danger'
                });
            }
        });
    }


    const displayNotUsed = row => {
        if (row.data.notUsed === undefined) {
            return <></>
        }

        if (row.data.notUsed) {
            return <i key={row.competence} className="pi pi-ban text-danger" onClick={ () => changeNotUsed(row.key) }  />
        }
        else {
            return <i key={row.competence} className="pi pi-chevron-down text-success" onClick={() => changeNotUsed(row.key)} />
        }
    }

    let resultHtml = <></>;

    if (result) {
        resultHtml = <div>
        <div className="accordion mb-4" id="accordionSonarNotPresent">
            <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingOne">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                        Skills dcgen non présentes dans pocahontas
                    </button>
                </h2>
                <div id="flush-collapseOne" className="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#accordionSonarNotPresent">
                    <DataTable value={result.skillsNotInPocahontas}  filters={filters} filterDisplay="row" 
                             emptyMessage="tous les skills dcgen sont importés dans pocahontas">
                        <Column field="nom" header="Skill" filter sortable />
                        <Column field="categorie" header="Catégorie" filter sortable />
                    </DataTable>
                </div>
            </div>
            </div>
            <div className="card" >
                    <div className="card-body">
                        <h3 className="card-title">Compétences similaires de pocahontas et liaison avec les Skills dcgen</h3>
                    <TreeTable value={tableRows} sortMode="multiple"  >
                        <Column field="competence" filterMatchMode="contains" sortable header="Compétence" filter expander></Column>
                        <Column field="skillName" filterMatchMode="contains" sortable header="skill dcgen" filter></Column>
                        <Column field="skillCategorie" filterMatchMode="contains" sortable header="catégorie dcgen" filter ></Column>
                        <Column body={ displayNotUsed } />
                    </TreeTable>
                    </div>
            </div>
        </div>
    }

    return resultHtml
}





